import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
	styled
} from '@mui/material';
import React from 'react';
import mobile from 'is-mobile';
import CloseIcon from '@mui/icons-material/Close';

const StyledDialog = styled(Dialog)({
	zIndex: 1500
});

const StyledDialogTitle = styled(DialogTitle)({
	backgroundColor: '#3DCD90',
	color: '#fff',
	padding: '8px 12px 8px 16px',
	width: '100%'
});

const StyledTitle = styled(Typography)({
	marginTop: 8
});

const StyledIconButton = styled(IconButton)({
	color: '#fff',
	margin: 0
});

const StyledCloseIcon = styled(CloseIcon)({
	color: '#fff'
});

const Modal = ({
	open,
	handleClose,
	icon,
	title,
	subtitle,
	actions: buttons,
	children,
	maxWidth,
	fullScreen
}) => {
	return (
		<StyledDialog
			fullWidth
			maxWidth={maxWidth || 'sm'}
			fullScreen={mobile() || fullScreen === true ? true : false}
			open={open}
			onClose={handleClose}
		>
			<StyledDialogTitle onClose={handleClose}>
				<Box display="flex" justifyContent="space-between">
					<Box display="flex" flexDirection="row">
						<StyledTitle variant="subtitle1">{title}</StyledTitle>
					</Box>
					<Box>
						<StyledIconButton onClick={handleClose}>
							<StyledCloseIcon />
						</StyledIconButton>
					</Box>
				</Box>
			</StyledDialogTitle>
			<DialogContent>
				{subtitle && <Typography variant="body1">{subtitle}</Typography>}
				<div>{children}</div>
			</DialogContent>
			{buttons && <DialogActions>{buttons}</DialogActions>}
		</StyledDialog>
	);
};

export default Modal;
